import http from '@/util/http'
export default {
  getInformList (data = {}) {
    return http({
      url: `/api/systemNotice/queryMessage/${data.page}/${data.size}`,
      method: 'post',
      data
    })
  }
}
